import {baseUrl} from './baseUrl';
import Parse from 'parse';

Parse.serverURL = baseUrl;
Parse.initialize('Hcwnq8U7xN4Z2bXcSBdvv4bjfRNKCpPSahXgeq9xRp');
